<template>
  <WdsModal
    ref="manage-modal"
    :show="show"
    :z-index="4000"
    :title="modalTitle"
    disable-click-outside
    @cancel="$emit('cancel')"
  >
    <AddForm
      v-if="!trustedContactId"
      :account-id="accountId"
      @cancel="$emit('cancel')"
      @close="$emit('close')"
      @added="$emit('added')"
    />

    <EditForm
      v-else
      :trusted-contact-id="trustedContactId"
      @cancel="$emit('cancel')"
      @close="$emit('close')"
      @updated="$emit('updated')"
    />
  </WdsModal>
</template>

<script setup>
import { computed } from 'vue'
import { WdsModal } from '@worksome/wds-components'

import AddForm from '@/components/Contacts/CompanyFreelancer/TrustedContactManageModal/AddForm.vue'
import EditForm from '@/components/Contacts/CompanyFreelancer/TrustedContactManageModal/EditForm.vue'

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },

  accountId: {
    type: String,
    required: true,
  },

  trustedContactId: {
    type: [String, null],
    required: true,
  },
})

defineEmits(['cancel', 'close', 'added', 'updated'])

const modalTitle = computed(() => {
  if (props.trustedContactId) {
    return $t('Edit Trusted Contact')
  }

  return $t('Invite Trusted Contact')
})
</script>
